module.exports = __webpack_public_path__ + "media/dashboard/assets/images/fb-badge-c71b1a0335031b15a239c475fc0d9154.png";